import classnames from "classnames";
import { UndoSvg } from "../inlinesvgs/UndoSvg";
import { RedoSvg } from "../inlinesvgs/RedoSvg";
import { I18N } from "oc-I18N";

const undoTitle = I18N("letzte Änderung rückgängig machen");
const redoTitle = I18N("letzte Änderung wiederherstellen");

export function UndoRedo() {
  return (
    <div
      className="flex-row undo-redo-buttons"
      role="group"
      aria-label={I18N("aria::Änderungsverlauf")}
    >
      <button
        className={classnames("svg-button-dotted", APP.undoHandler.canUndo() && "active")}
        title={undoTitle}
        aria-label={undoTitle}
        aria-disabled={!APP.undoHandler.canUndo()}
        data-button-key="undo"
        onClick={() => {
          APP.undoHandler.undo();
          APP.logUserAction({ action: "undo" }, { stateChange: false });
        }}
      >
        <UndoSvg />
      </button>
      <button
        className={classnames("svg-button-dotted", APP.undoHandler.canRedo() && "active")}
        title={redoTitle}
        aria-label={redoTitle}
        aria-disabled={!APP.undoHandler.canRedo()}
        data-button-key="redo"
        onClick={() => {
          APP.undoHandler.redo();
          APP.logUserAction({ action: "redo" }, { stateChange: false });
        }}
      >
        <RedoSvg />
      </button>
    </div>
  );
}
